const events = [
  {
    id: "day-1",
    time: "08:30",
    session: "Registration & welcome coffee",
    info: "Pick up your name badge and meet your coaches.",
    location: "Foyer",
    track: "Break",
  },
  {
    id: "day-2",
    time: "08:30",
    session: "Morning coffee",
    info: "Ease into day two before we build.",
    location: "Foyer",
    track: "Break",
  },
  {
    id: "day-1",
    time: "10:30",
    session: "Installation party & environment setup",
    info: "Get Python, an editor and Django installed and ready.",
    location: "Room A",
    track: "Workshop",
  },
  {
    id: "day-2",
    time: "09:00",
    session: "Views, URLs & templates",
    info: "Show your data on a real web page.",
    location: "Room A",
    track: "Workshop",
  },
  {
    id: "day-1",
    time: "11:00",
    session: "Tea break",
    info: "Refuel and chat with the group.",
    location: "Terrace",
    track: "Break",
  },
  {
    id: "day-2",
    time: "10:30",
    session: "Stretch and recharge.",
    info: "Tea break",
    location: "Terrace",
    track: "Break",
  },
  {
    id: "day-1",
    time: "11:30",
    session: "Command line & Python basics",
    info: "Your first commands, variables, loops and functions.",
    location: "Room A",
    track: "Workshop",
  },
  {
    id: "day-2",
    time: "11:00",
    session: "Dynamic data, the Django ORM",
    info: "Query and save data without writing SQL.",
    location: "Room A",
    track: "Workshop",
  },
  {
    id: "day-1",
    time: "12:00",
    session: "Lunch",
    info: "Catered lunch together.",
    location: "Dining Hall",
    track: "Break",
  },
  {
    id: "day-2",
    time: "13:00",
    session: "Lunch",
    info: "Catered lunch together.",
    location: "Dining Hall",
    track: "Break",
  },
  {
    id: "day-1",
    time: "13:00",
    session: "How the web works (HTTP & requests)",
    info: "What happens between a browser and a server.",
    location: "Room A",
    track: "Workshop",
  },
  {
    id: "day-2",
    time: "14:00",
    session: "Django forms, let users post",
    info: "Add, edit and save content from the browser.",
    location: "Room A",
    track: "Workshop",
  },
  {
    id: "day-1",
    time: "15:30",
    session: "Your first Django project, models",
    info: "Create a project and design your first data model.",
    location: "Room A",
    track: "Workshop",
  },
  {
    id: "day-2",
    time: "15:30",
    session: "Deploy your app to the web",
    info: "Put your Django app online for the world to see.",
    location: "Room A",
    track: "Workshop",
  },
  {
    id: "day-1",
    time: "16:30",
    session: "Wrap-up & mentor Q&A",
    info: "Recap the day and ask your coaches anything.",
    location: "Room A",
    track: "Q&A",
  },
  {
    id: "day-2",
    time: "16:30",
    session: "Show & tell + certificates",
    info: "Demo what you built and collect your certificate.",
    location: "Room A",
    track: "Community",
  },
];

export function getEvent() {
  return events;
}
